/**
 * Aureliseé, het megamenu: de twee tabbladen en de carrousel.
 * Overgenomen uit het Dawn-thema.
 *
 * Wisselen van tabblad gaat op hover en op focus, zodat het ook met het
 * toetsenbord werkt. De stand staat als data-au-tab op het paneel; de CSS regelt
 * wat zichtbaar is. Zo blijft het openstaan als je van de tab naar de inhoud
 * beweegt. Gaat het menu dicht, dan staat Featured weer voor.
 *
 * De carrousel schuift per kaartje. De pijlen verdwijnen aan het begin en het
 * eind, net als in Dawn.
 *
 * Zonder javascript blijft Featured staan en werken alle links gewoon.
 *
 * Zie snippets/au-bouwlog.liquid.
 */

/**
 * @param {Element} tab
 */
function selectTab(tab) {
  const root = tab.closest('[data-au-mega]');
  const value = tab.getAttribute('data-au-mega-tab');
  if (!root || !value || root.getAttribute('data-au-tab') === value) return;

  root.setAttribute('data-au-tab', value);

  for (const other of root.querySelectorAll('[data-au-mega-tab]')) {
    other.setAttribute('aria-selected', String(other === tab));
  }
}

for (const event of ['pointerenter', 'focusin']) {
  document.addEventListener(
    event,
    (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      const tab = target.closest('[data-au-mega-tab]');
      if (tab) selectTab(tab);
    },
    true
  );
}

/* Een klik op een tab mag de pagina niet verlaten of het menu sluiten. */
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const tab = target.closest('[data-au-mega-tab]');
  if (tab) {
    event.preventDefault();
    selectTab(tab);
    return;
  }

  const arrow = target.closest('[data-au-feat-prev], [data-au-feat-next]');
  if (!arrow) return;
  event.preventDefault();

  const wrap = arrow.closest('.au-featrow-wrap');
  const row = wrap?.querySelector('[data-au-featrow]');
  if (!row) return;

  const first = row.firstElementChild;
  const step = (first ? first.getBoundingClientRect().width : 240) + 16;
  const direction = arrow.hasAttribute('data-au-feat-prev') ? -1 : 1;

  glide(row, row.scrollLeft + direction * step);
});

/**
 * Schuift de rij in kleine stapjes naar zijn doel. Dit doen we zelf, want een
 * vloeiende scroll van de browser wordt in dit paneel afgebroken en dan gebeurt
 * er niets.
 * @param {Element} row
 * @param {number} target
 */
function glide(row, target) {
  const start = row.scrollLeft;
  const max = row.scrollWidth - row.clientWidth;
  const end = Math.max(0, Math.min(max, target));
  const duration = 320;
  const started = Date.now();

  /* Bewust met een timer en niet met requestAnimationFrame: die staat stil zodra
     het tabblad op de achtergrond komt, en dan zou de pijl niets doen. */
  function step() {
    const t = Math.min(1, (Date.now() - started) / duration);
    const eased = 1 - Math.pow(1 - t, 3);
    row.scrollLeft = start + (end - start) * eased;
    if (t < 1) {
      setTimeout(step, 16);
    } else {
      row.scrollLeft = end;
      syncArrows(row);
    }
  }

  step();
}

/**
 * Verbergt de pijl die niets meer te doen heeft.
 * @param {Element} row
 */
function syncArrows(row) {
  const wrap = row.closest('.au-featrow-wrap');
  if (!wrap) return;

  const prev = wrap.querySelector('[data-au-feat-prev]');
  const next = wrap.querySelector('[data-au-feat-next]');
  const max = row.scrollWidth - row.clientWidth;

  if (prev instanceof HTMLElement) prev.hidden = row.scrollLeft <= 4;
  if (next instanceof HTMLElement) next.hidden = row.scrollLeft >= max - 4;
}

/**
 * Meet het beeld van het eerste kaartje en zet die hoogte op de collectielijst, zodat
 * de bovenkant van het beeld gelijk ligt met de eerste collectie en de onderkant
 * met de laatste. De CSS verdeelt de collecties dan gelijkmatig over die hoogte.
 */
function alignCats() {
  for (const mega of document.querySelectorAll('[data-au-mega]')) {
    const media = mega.querySelector('.au-featrow .au-card__media');
    const cats = mega.querySelector('.au-cats');
    if (!media || !cats) continue;
    const height = media.getBoundingClientRect().height;
    if (height > 0) cats.style.setProperty('--au-cats-height', `${height}px`);
  }
}

/**
 * Houdt het paneel open zolang de muis onderweg is van de menulink naar het
 * paneel. Vessel sluit direct bij het verlaten van de link; hier krijgt de muis
 * eerst een korte pauze. Staat hij daarna niet op het paneel, dan sluiten we alsnog
 * via de eigen methode van Vessel. Alleen voor het item met het eigen paneel.
 */
const GRACE = 400;

document.addEventListener(
  'pointerleave',
  (event) => {
    const item = event.target;
    if (!(item instanceof Element) || !item.matches('.menu-list__list-item')) return;
    if (!item.querySelector('[data-au-mega]')) return;

    const to = event.relatedTarget;
    if (to instanceof Node && item.contains(to)) return;
    /* naar een ander menu-item: laat Vessel het gewoon wisselen */
    if (to instanceof Element && to.closest('.menu-list__list-item')) return;

    event.stopPropagation();
    clearTimeout(item.auGraceTimer);
    item.auGraceTimer = setTimeout(() => {
      if (item.matches(':hover')) return;
      const menu = item.closest('header-menu');
      const link = item.querySelector('[ref="menuitem"]');
      if (menu && typeof menu.deactivate === 'function' && link) {
        menu.deactivate({ target: link, relatedTarget: null });
      }
    }, GRACE);
  },
  true
);

/**
 * Mobiel menu: er staat altijd maar een accordeon open.
 */
document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.hasAttribute('data-au-macc') || !details.open) return;
    const root = details.closest('[data-au-mobile]');
    if (!root) return;
    for (const other of root.querySelectorAll('[data-au-macc]')) {
      if (other !== details && other instanceof HTMLDetailsElement) other.open = false;
    }
  },
  true
);

/**
 * Elke keer dat het menu dichtgaat, staat Featured weer voor.
 */
/**
 * Bolletjes onder een collectiecarrousel (Discover all collections), alleen op de
 * telefoon (de css verbergt ze op desktop). Een bolletje per collectie; de
 * bolletjes van de kaartjes die in beeld zijn krijgen de kleur van het schema.
 * Welk kaartje in beeld is, wordt bij elke schuifbeweging gemeten op de schuifbak
 * van Vessel, dus dit hangt niet aan de binnenkant van zijn slideshow-component.
 * Klik op een bolletje schuift naar dat kaartje.
 */
function initDots() {
  for (const show of document.querySelectorAll('.resource-list__carousel slideshow-component')) {
    if (show.dataset.auDots) continue;
    /* alleen de collectiecarrousel; een productcarrousel gebruikt dezelfde opbouw */
    if (!show.querySelector('.collection-card')) continue;
    const slides = [...show.querySelectorAll('slideshow-slide')];
    if (slides.length < 2) continue;
    show.dataset.auDots = '1';

    const dots = document.createElement('div');
    dots.className = 'au-dots';
    dots.setAttribute('data-au-dots', '');
    const buttons = slides.map((slide, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'au-dots__dot';
      button.setAttribute('aria-label', String(index + 1));
      button.addEventListener('click', () => {
        if (typeof show.select === 'function') {
          show.select(index);
        } else {
          slide.scrollIntoView({ block: 'nearest', inline: 'start' });
        }
        setTimeout(() => show.dispatchEvent(new Event('au:dots-sync')), 700);
      });
      dots.append(button);
      return button;
    });
    show.after(dots);

    /* welk kaartje in beeld is: gemeten op de schuifbak, bij elke schuifbeweging */
    const scroller = show.querySelector('slideshow-slides') || show;
    const sync = () => {
      const box = scroller.getBoundingClientRect();
      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const visible = Math.max(0, Math.min(rect.right, box.right) - Math.max(rect.left, box.left));
        buttons[index].classList.toggle('au-dots__dot--on', rect.width > 0 && visible / rect.width >= 0.6);
      });
    };
    scroller.addEventListener('scroll', sync, { passive: true });
    scroller.addEventListener('scrollend', sync);
    show.addEventListener('au:dots-sync', sync);
    window.addEventListener('resize', sync);
    sync();
    setTimeout(sync, 400);
  }
}

/**
 * Balkje onder de fotogalerij op de productpagina (telefoon). Het gekleurde deel
 * is zo breed als het zichtbare deel van de foto's en schuift mee met het vegen.
 */
function initGalleryBar() {
  for (const show of document.querySelectorAll('media-gallery slideshow-component')) {
    if (show.dataset.auGalbar) continue;
    const scroller = show.querySelector('slideshow-slides');
    if (!scroller || show.querySelectorAll('slideshow-slide').length < 2) continue;
    show.dataset.auGalbar = '1';

    const bar = document.createElement('div');
    bar.className = 'au-galbar';
    bar.setAttribute('aria-hidden', 'true');
    const fill = document.createElement('span');
    fill.className = 'au-galbar__fill';
    bar.append(fill);
    show.after(bar);

    const sync = () => {
      const total = scroller.scrollWidth || 1;
      const part = Math.min(100, (scroller.clientWidth / total) * 100);
      fill.style.width = `${part}%`;
      fill.style.transform = `translateX(${(scroller.scrollLeft / scroller.clientWidth) * 100}%)`;
    };
    scroller.addEventListener('scroll', sync, { passive: true });
    scroller.addEventListener('scrollend', sync);
    window.addEventListener('resize', sync);
    sync();
    setTimeout(sync, 400);
    /* vangnet: Vessel schuift de galerij zelf (overflow hidden); als een browser
       daar geen scroll-gebeurtenis bij geeft, kijkt dit elke 200ms of er iets
       verschoven is */
    let last = scroller.scrollLeft;
    setInterval(() => {
      if (scroller.scrollLeft !== last) {
        last = scroller.scrollLeft;
        sync();
      }
    }, 200);
  }
}

/**
 * Doorbladeren in de fotogalerij op de productpagina loopt rond: na de laatste
 * foto komt de eerste. Vessel's pijl blijft het werk doen, alleen bij de laatste
 * foto nemen we het over en springen naar de eerste. Uit te zetten via de
 * instelling (--au-gal-loop).
 */
document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const next = target.closest('media-gallery .slideshow-control--next');
    if (!next) return;
    if (getComputedStyle(document.documentElement).getPropertyValue('--au-gal-loop').trim() === '0') return;
    const show = next.closest('slideshow-component');
    if (!show || typeof show.select !== 'function') return;
    const slides = [...show.querySelectorAll('slideshow-slide')];
    const current = slides.findIndex((slide) => slide.getAttribute('aria-hidden') !== 'true');
    if (current === slides.length - 1) {
      event.preventDefault();
      event.stopPropagation();
      show.select(0);
    }
  },
  true
);

/**
 * Fotogalerij op desktop (Jesse, 13 oktober 2026): geen pijlen op de foto. Over de
 * linker- en rechterhelft van de foto ligt een vast vlak (.au-galzone, met een eigen
 * muisicoon in au-menu.css); een klik op het rechter vlak gaat vooruit, op het linker
 * terug, via Vessel's eigen select() en teller; het loopt rond (na de laatste de
 * eerste, voor de eerste de laatste), tenzij --au-gal-loop op 0 staat. De
 * vlakken liggen in slideshow-container, dus niet over de thumbnails. Omdat de klik
 * op het vlak landt en niet op de dia, gaat de zoom van Vessel niet open. Onder 750px
 * staan de vlakken uit (css): daar veegt de klant en tikken zoomt. De eerste versie
 * schakelde per muisbeweging een klasse op de dia en haperde; vandaar vaste vlakken.
 */
function initGalleryZones() {
  for (const container of document.querySelectorAll('media-gallery slideshow-container')) {
    /* alleen bij twee of meer foto's: bij één foto geen vlakken, dus geen pijltje op de
       telefoon en geen chevron als muisaanwijzer op de computer (Jesse, 31 oktober 2026) */
    const slides = container.querySelectorAll('slideshow-slide:not([hidden])').length;
    if (slides < 2) {
      for (const zone of container.querySelectorAll('.au-galzone')) zone.remove();
      continue;
    }
    if (container.querySelector('.au-galzone')) continue;
    for (const side of ['prev', 'next']) {
      const zone = document.createElement('div');
      zone.className = 'au-galzone au-galzone--' + side;
      zone.setAttribute('data-au-galzone', side);
      zone.setAttribute('aria-hidden', 'true');
      container.appendChild(zone);
    }
  }
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const zone = target.closest('[data-au-galzone]');
  if (!zone) return;
  const show = /** @type {any} */ (zone.closest('slideshow-component'));
  if (!show || typeof show.select !== 'function') return;
  /* Vessel's teller (show.current) loopt pas bij na het schuiven; klik je snel achter
     elkaar, dan telt dit verder vanaf de foto waar we al heen gaan (show.auTarget,
     weg zodra het schuiven klaar is) */
  const count = show.querySelectorAll('slideshow-slide').length;
  if (count < 2) return;
  const current = typeof show.auTarget === 'number' ? show.auTarget : Number(show.current) || 0;
  const next = zone.getAttribute('data-au-galzone') === 'next';
  const loop = getComputedStyle(document.documentElement).getPropertyValue('--au-gal-loop').trim() !== '0';
  let index = current + (next ? 1 : -1);
  if (index < 0) index = loop ? count - 1 : 0;
  if (index > count - 1) index = loop ? 0 : count - 1;
  if (index === current) return;
  show.auTarget = index;
  clearTimeout(show.auTargetTimer);
  show.auTargetTimer = setTimeout(() => {
    show.auTarget = undefined;
  }, 1500);
  const scroller = show.querySelector('slideshow-slides');
  if (scroller && !show.auTargetEnd) {
    show.auTargetEnd = true;
    scroller.addEventListener('scrollend', () => {
      show.auTarget = undefined;
    });
  }
  show.select(index);
});

/**
 * Beeld-of-videoblok: onder 750px de telefoonvariant (uit de <template>), erboven
 * de desktopvariant. Er laadt maar één van de twee. Zonder telefoonvariant
 * gebeurt er niets.
 */
function initMediaSwap() {
  for (const box of document.querySelectorAll('[data-au-media]')) {
    if (box.dataset.auSwap) continue;
    const template = box.querySelector('template[data-au-media-mobile]');
    if (!template) continue;
    box.dataset.auSwap = '1';
    const desktop = document.createElement('template');
    for (const node of [...box.childNodes]) {
      if (node !== template) desktop.content.append(node);
    }
    const query = window.matchMedia('(max-width: 749px)');
    const apply = () => {
      for (const node of [...box.childNodes]) {
        if (node !== template) node.remove();
      }
      const source = query.matches ? template : desktop;
      box.append(source.content.cloneNode(true));
      const video = box.querySelector('video[autoplay]');
      if (video && typeof video.play === 'function') video.play().catch(() => {});
    };
    apply();
    query.addEventListener('change', apply);
  }
}

function bind() {
  alignCats();
  initDots();
  initGalleryBar();
  initGalleryZones();
  initMediaSwap();

  for (const row of document.querySelectorAll('[data-au-featrow]')) {
    if (row.dataset.auBound) continue;
    row.dataset.auBound = '1';
    row.addEventListener('scroll', () => syncArrows(row), { passive: true });
    syncArrows(row);
  }

  for (const mega of document.querySelectorAll('[data-au-mega]')) {
    const item = mega.closest('.menu-list__list-item');
    if (!item || item.dataset.auMegaReset) continue;
    item.dataset.auMegaReset = '1';
    item.addEventListener('pointerleave', () => {
      mega.setAttribute('data-au-tab', '1');
      for (const tab of mega.querySelectorAll('[data-au-mega-tab]')) {
        tab.setAttribute('aria-selected', String(tab.getAttribute('data-au-mega-tab') === '1'));
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bind);
} else {
  bind();
}

document.addEventListener('shopify:section:load', bind);
window.addEventListener('resize', () => {
  for (const row of document.querySelectorAll('[data-au-featrow]')) syncArrows(row);
  alignCats();
});
window.addEventListener('load', alignCats);

/**
 * Telefoonmenu: Search sluit eerst de lade en opent daarna Vessel's zoekvenster
 * (Jesse, 14 oktober 2026). Pas als de lade echt dicht is (toggle van zijn details),
 * anders houdt Vessel's focusval de focus in de lade en kun je niet typen.
 */
document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element ? event.target.closest('[data-au-search]') : null;
  if (!trigger) return;
  event.preventDefault();
  const modal = document.getElementById('search-modal');
  const open = () => {
    if (modal && typeof modal.showDialog === 'function') modal.showDialog();
  };
  const drawer = trigger.closest('header-drawer');
  const details = drawer ? drawer.querySelector(':scope > details') : null;
  if (!drawer || !details || !details.open || typeof drawer.close !== 'function') {
    open();
    return;
  }
  let done = false;
  const go = () => {
    if (done) return;
    done = true;
    open();
  };
  details.addEventListener('toggle', () => setTimeout(go, 0), { once: true });
  setTimeout(go, 1200);
  drawer.close();
});

/**
 * Live chat (Shopify's <shopify-chat>) net boven de taalbalk onder in het paneel
 * Region and language van het telefoonmenu, zolang dat paneel open is (Jesse,
 * 14 oktober 2026). De chatknop zit in een eigen laag over het hele scherm; die laag
 * schuift precies zo ver omhoog dat de knop 8px boven de balk staat, en gaat terug
 * zodra het paneel dicht is. De maten worden gemeten, dus het klopt ook als de knop
 * in de chatinstellingen ergens anders staat.
 */
(() => {
  const GAP = 8;
  const loc = document.getElementById('drawer-localization');
  if (!loc) return;
  const reset = (chat) => chat.style.removeProperty('transform');
  const place = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;
    chat.style.transition = 'transform 0.25s ease';
    if (!loc.classList.contains('menu-open')) {
      reset(chat);
      return;
    }
    const bar = loc.querySelector('.language-selector');
    const root = chat.shadowRoot;
    const parts = root ? [...root.querySelectorAll('.activator-nudge, .activator')] : [];
    if (!bar || parts.length === 0) return;
    reset(chat);
    const barTop = bar.getBoundingClientRect().top;
    const bottom = Math.max(...parts.map((part) => part.getBoundingClientRect().bottom));
    const shift = Math.ceil(bottom - (barTop - GAP));
    if (shift > 0) chat.style.setProperty('transform', `translateY(${-shift}px)`);
  };
  new MutationObserver(place).observe(loc, { attributes: true, attributeFilter: ['class', 'open'] });
})();
